import { uniq } from 'lodash'

// Returns an array of the distinct positions from an array of positions

function distinctEmploymentPositions(employments) {
  return uniq(employments.map((employment) => employment.position))
}

export default distinctEmploymentPositions
